import src from "IMAGE";
export default { src, width: 230, height: 56, blurWidth: 0, blurHeight: 0};
